export interface Event {
  id: number;
  timezone: string;
  startTime: Date;
  endTime: Date;
  enrollmentOpenTime: Date;
  enrollmentDeadline: Date;
  enrollmentUrl: string;
  participantCapacity: number | null;
  participantCount: number;
  name: string;
  location: string;
  address: string;
  city: string;
  category: EventCategory;
}

export enum EventCategory {
  Event = "EVENT",
  Training = "TRAINING",
}

/**
 * RawEvent is Lyyti data decorated by Access micro service. Only those fields that
 * are used by Access UI are defined in the interface (for all fields available, see
 * core/backend/src/mock_data/event/events.json). UTC timestamps are in seconds.
 */
export interface RawEvent {
  // Fields from Lyyti
  event_id: number;
  timezone: string;
  start_time_utc: number;
  end_time_utc: number;
  enrollment_open_utc: number;
  enrollment_deadline_utc: number;
  enrollment_url: string;
  participant_capacity: number | null;
  participant_count: number;
  language: string[];
  name: TranslatedString;
  location: TranslatedString;
  address: TranslatedString;
  // Fields added by Access micro service
  iloqAccessMappings: IloqAccessMappings;
}

export interface TranslatedString {
  [key: string]: string; // Key is ISO 669-1 code
}

export interface IloqAccessMappings {
  city: string;
  category: EventCategory;
}
